import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import OrderPage from "@/pages/OrderPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import StaffLoginPage from "@/pages/StaffLoginPage";
import StaffDashboard from "@/pages/StaffDashboard";
import StaffProducts from "@/pages/StaffProducts";
import QurbaniPage from "@/pages/QurbaniPage";
import TimeCardPage from "@/pages/TimeCardPage";
import InvoicesPage from "@/pages/InvoicesPage";
import SchedulePage from "@/pages/SchedulePage";
import MySchedulePage from "@/pages/MySchedulePage";
import KioskPunchPage from "@/pages/KioskPunchPage";
import MetricsPage from "@/pages/MetricsPage";
import WeeklyReportPage from "@/pages/WeeklyReportPage";
import PayrollPage from "@/pages/PayrollPage";
import EmployeeOnboardPage from "@/pages/EmployeeOnboardPage";
import AIInsightsPage from "@/pages/AIInsightsPage";
import KioskSecurePage from "@/pages/KioskSecurePage";
import KioskInstallPage from "@/pages/KioskInstallPage";
import TestPunchesPage from "@/pages/TestPunchesPage";
import EmployeeBulkEditPage from "@/pages/EmployeeBulkEditPage";
import FaceEnrollPage from "@/pages/FaceEnrollPage";
import SandboxOnboardPage from "@/pages/SandboxOnboardPage";
import HolidaySheetPage from "@/pages/HolidaySheetPage";
import HRPage from "@/pages/HRPage";
import RequestTimeOffPage from "@/pages/RequestTimeOffPage";
import TimesheetPage from "@/pages/TimesheetPage";
import TenantGate from "@/components/TenantGate";

function App() {
  return (
    <div className="App min-h-screen bg-[#F9F7F2]">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/qurbani" element={<QurbaniPage />} />
          <Route path="/track" element={<TrackOrderPage />} />
          <Route path="/track/:orderId" element={<TrackOrderPage />} />
          <Route path="/staff" element={<StaffLoginPage />} />
          <Route path="/staff/dashboard" element={<StaffDashboard />} />
          <Route path="/staff/products" element={<StaffProducts />} />
          <Route path="/timecard" element={<TenantGate><TimeCardPage /></TenantGate>} />
          <Route path="/paypunch" element={<TenantGate><TimeCardPage /></TenantGate>} />
          <Route path="/paypunch/admin" element={<TenantGate><TimeCardPage /></TenantGate>} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/schedule" element={<TenantGate><SchedulePage /></TenantGate>} />
          <Route path="/myschedule" element={<TenantGate><MySchedulePage /></TenantGate>} />
          <Route path="/kiosk" element={<TenantGate><KioskPunchPage /></TenantGate>} />
          <Route path="/kiosk-punch" element={<TenantGate><KioskPunchPage /></TenantGate>} />
          <Route path="/metrics" element={<TenantGate><MetricsPage /></TenantGate>} />
          <Route path="/weekly-report" element={<TenantGate><WeeklyReportPage /></TenantGate>} />
          <Route path="/report" element={<TenantGate><WeeklyReportPage /></TenantGate>} />
          <Route path="/payroll" element={<TenantGate><PayrollPage /></TenantGate>} />
          <Route path="/wageup" element={<TenantGate><PayrollPage /></TenantGate>} />
          <Route path="/ai" element={<TenantGate><AIInsightsPage /></TenantGate>} />
          <Route path="/insights" element={<TenantGate><AIInsightsPage /></TenantGate>} />
          <Route path="/kiosk-secure" element={<TenantGate><KioskSecurePage /></TenantGate>} />
          <Route path="/kiosk-pro" element={<TenantGate><KioskSecurePage /></TenantGate>} />
          <Route path="/kiosk-test" element={<TenantGate><KioskSecurePage /></TenantGate>} />
          <Route path="/sandbox" element={<TenantGate><SandboxOnboardPage /></TenantGate>} />
          <Route path="/hr/pto-sheet" element={<TenantGate><HolidaySheetPage /></TenantGate>} />
          <Route path="/hr" element={<TenantGate><HRPage /></TenantGate>} />
          <Route path="/request-off" element={<TenantGate><RequestTimeOffPage /></TenantGate>} />
          <Route path="/timesheet" element={<TenantGate><TimesheetPage /></TenantGate>} />
          <Route path="/test-punches" element={<TenantGate><TestPunchesPage /></TenantGate>} />
          <Route path="/kiosk-install" element={<TenantGate><KioskInstallPage /></TenantGate>} />
          <Route path="/employees-bulk" element={<TenantGate><EmployeeBulkEditPage /></TenantGate>} />
          <Route path="/face-enroll" element={<TenantGate><FaceEnrollPage /></TenantGate>} />
          <Route path="/onboard/:token" element={<EmployeeOnboardPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
